<script lang="ts" setup>
import PatientAvatar from '@/components/PatientAvatar.vue';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import type { ChatProfileDataSent } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatMessage from '@sigma/ui/chat/ChatMessage.vue';
import ChatProfileData from '@sigma/ui/chat/ChatProfileData.vue';

import chatCss from './chat.module.scss';
import * as l from './ChatProfileDataSent.loc.js';

defineProps(defineChatEventProps<ChatProfileDataSent>());
const t = useTranslate();
</script>

<template>
  <ChatEventWrapper
    :event="event"
    :class="chatCss.container"
  >
    <ChatMessage
      color="blue"
      align="right"
      :timestamp="event.timestamp"
    >
      <template #avatar>
        <PatientAvatar />
      </template>

      <template #content>
        <ChatProfileData
          :profile="event.profile"
          :title="t(l.title)"
        />
      </template>
    </ChatMessage>
  </ChatEventWrapper>
</template>
